// @ts-ignore
import animateScrollTo from "animated-scroll-to"
// @ts-ignore
import debounce from 'lodash/debounce';
import {Utils} from "./Utils";
Utils.executeWhenDocumentIsReady( () => {
    const sectionMenu = document.querySelector<HTMLElement>(".c-section-menu")
    if (sectionMenu && sectionMenu.querySelector("ol li")) {
        const sectionMenuHeadline = sectionMenu.querySelector(
            ".c-section-menu__headline",
        ) as HTMLElement
        const sectionMenuHeadlineWidth = sectionMenuHeadline.offsetWidth

        const sectionMenuList = sectionMenu.querySelector("ol") as HTMLElement
        sectionMenuList.style.display = "block"
        let sectionMenuListHeight = sectionMenuList.offsetHeight
        sectionMenuList.style.display = "none"
        const initialTransform = `rotate(-90deg) translate(0px, -${sectionMenuHeadline.offsetHeight}px)`

        const sectionMenuPlaceholder = sectionMenu.querySelector<HTMLElement>(
            ".c-section-menu__placeholder",
        ) as HTMLElement
        sectionMenuPlaceholder.style.height = `${sectionMenuListHeight}px`
        sectionMenuPlaceholder.style.width = `${sectionMenuHeadlineWidth}px`

        sectionMenu.style.transform = initialTransform

        window.addEventListener('resize', debounce(() => {
          if (sectionMenuList.style.display === 'block') {
            return
          }
          sectionMenuList.style.display = "block"
          sectionMenuListHeight = sectionMenuList.offsetHeight;
          sectionMenuList.style.display = "none"
          sectionMenuPlaceholder.style.height = `${sectionMenuListHeight}px`
        }, 100));

        sectionMenuHeadline
            .querySelector("span")
            ?.addEventListener("click", function () {
                sectionMenuHeadline.classList.add(
                    "c-section-menu__headline--clicked",
                )
                sectionMenu.style.transform = "rotate(0deg) translate(0px, 0px)"
                sectionMenuPlaceholder.style.display = "none"
                sectionMenuList.style.display = "block"
            })

        sectionMenu
            .querySelector(".c-section-menu__headline-close")
            ?.addEventListener("click", function () {
                sectionMenuHeadline.classList.remove(
                    "c-section-menu__headline--clicked",
                )
                sectionMenu.style.transform = initialTransform
                sectionMenuListHeight = sectionMenuList.offsetHeight;
                sectionMenuList.style.display = "none"
                sectionMenuPlaceholder.style.height = `${sectionMenuListHeight}px`
                sectionMenuPlaceholder.style.display = "block"
            })

        sectionMenu
            .querySelectorAll<HTMLAnchorElement>("ol li a")
            .forEach((link) => {
                link.addEventListener("click", function (e) {
                    e.preventDefault()

                    const hrefParts = this.href.split("#")
                    if (hrefParts[1]) {
                        const scrollToElement = document.getElementById(
                            hrefParts[1],
                        )
                        const headerOffset = (
                            document.querySelector(".c-header") as HTMLElement
                        ).clientHeight

                        animateScrollTo(scrollToElement, {
                            verticalOffset: -headerOffset,
                            maxDuration: 1500,
                        }).then((hasScrolledToPosition) => {
                            //console.log(hasScrolledToPosition);
                        })
                    }
                })
            })
    }
})
